import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { Images } from '../../../../assets';
import ScrollableTable from '../../../../component/ScrollableTable';
import moment from 'moment';
import { getTimeRange } from '../../../../helpers';
import { RestartAlt } from '@mui/icons-material';

const SlotsBooked = (props) => {
    const { meetingSlot } = props;
    const [userList, setUserList] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [sortedColumns, setSortedColumns] = useState(null);

    const userHeader = [
        { label: 'User Name', sortable: 'username' },
        { label: 'Start Date' },
        { label: 'End Date' },
        { label: 'Start Time' },
        { label: 'End Time' },
    ];

    useEffect(() => {
        if (meetingSlot) {
            const tempList = meetingSlot.map(({ user, ...args }) => ({
                ...args,
                username: `${user?.firstname} ${user?.lastname}`
            }));
            setUserList(tempList)
        } else {
            setUserList([])
        }
    }, [meetingSlot])

    useEffect(() => {
        if (sortedColumns) {
            let tableData = Object.assign([], userList)
            if (sortedColumns?.direction === 'desc') {
                tableData = tableData?.sort((a, b) => b[sortedColumns?.key]?.localeCompare(a[sortedColumns?.key]));
            } else {
                tableData = tableData?.sort((a, b) => a[sortedColumns?.key]?.localeCompare(b[sortedColumns?.key]));
            }
            setUserList(tableData)
        } else {
            setUserList(userList)
        }
    }, [sortedColumns])

    const handleUserName = (keyValue, defaultValue, meetingLink) => {
        return (
            <div className={`w-[50%] ${classes.redirectURL}`}>
                <a href={meetingLink} target='blank'>{keyValue ? keyValue : defaultValue}</a>
            </div>
        )
    };
    const handleTableData = (keyValue, defaultValue, className = '') => {
        return (
            <div className={`${className} w-[50%]`}>{keyValue ? keyValue : defaultValue}</div>
        )
    };

    return (
        <div className={`eventWrapper`}>
            <div className={`component-title flex items-center`}>
                <div className='label'>Booked Slots</div>
                <div className='vector'></div>
            </div>
            <div className={`my-5 scrollTableWrapper ${classes.slotTableWrapper}`}>
                <ScrollableTable
                    headerDetails={userHeader}
                    listLength={userList || []}
                    isLoading={isLoading}
                    tableSort
                    sortedColumns={sortedColumns}
                    setSortedColumns={setSortedColumns}
                >
                    {userList?.map((item, index) => {
                        const { username = '', isBooked = false, startTime = '', endTime = '', meetingLink = '', id = '' } = item;
                        return (
                            <div className={`flex items-center rowTableData `} key={id}>
                                {handleUserName(username, '-', meetingLink)}
                                {handleTableData(moment(startTime)?.format("DD MMM YYYY"), '-', 'text-center')}
                                {handleTableData(moment(endTime)?.format("DD MMM YYYY"), '-', 'text-center')}
                                {handleTableData(getTimeRange(startTime), '-', 'text-center')}
                                {handleTableData(getTimeRange(endTime), '-', 'text-center')}
                            </div>
                        );
                    })}
                </ScrollableTable>
            </div>
        </div>
    )
}

export default SlotsBooked